module.exports = __webpack_public_path__ + "static/media/03_variedades.8084698c.jpg";